module.exports = __webpack_public_path__ + "static/img/logo-2021-04.aaa3ca4c.png";